<template>
  <div class="c-header-nav-more">
    <!-- social -->
    <app-header-nav-more-social />
    <!-- lang -->
    <app-header-nav-more-local />
  </div>
</template>

<script>
import AppHeaderNavMoreLocal from "components/AppHeader/AppHeaderNav/AppHeaderNavMore/AppHeaderNavMoreLocal/AppHeaderNavMoreLocal";
import AppHeaderNavMoreSocial from "components/AppHeader/AppHeaderNav/AppHeaderNavMore/AppHeaderNavMoreSocial/AppHeaderNavMoreSocial";
export default {
  components: {
    AppHeaderNavMoreLocal,
    AppHeaderNavMoreSocial
  }
};
</script>

<style lang="scss">
.c-header-nav-more {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  @media #{$breakpoint-horizontal} {
    flex-direction: row;
    justify-content: space-between;
  }
}
</style>
